// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"645":"30c8c210","2584":"7ce304ca","6021":"12d41979","6257":"7ce304ca","7603":"c985f637","7620":"7bdfb7c3","8379":"3b2bdf7a"}[chunkId] + ".chunk.css";
};